import Helper from '../models/Helper';
import type { ClientApiInterface } from '../../..';

export default function getHelper<EntityType>(
  uri: string,
  subItemsHelpers: Record<string, typeof Helper> = {}
): typeof Helper {
  return class extends Helper<EntityType> {
    constructor(api: ClientApiInterface, parentURI: string = '') {
      super(api, parentURI + uri);
      this.subItemsHelpers = subItemsHelpers;
    }
  };
}
